// The Memberships tab (F-MEM-01 … F-MEM-07, spec/06 §6): not built yet. There is no membership service
// on the server, so the tab says what it will hold and nothing pretends otherwise (design guide,
// principle 6: honest unbuilt states).

import { useTranslation } from '@clavian/i18n/react';
import { Chip, EmptyState } from '@clavian/ui-web';
import type { ReactNode } from 'react';

import { NavIcon } from '../../shell/nav-icons';

export function MembershipsTab(): ReactNode {
  const { t } = useTranslation('console');
  const areas = t('pricing.memberships.areas', { returnObjects: true }) as unknown;
  return (
    <div className="console-pricing-panel">
      <EmptyState
        icon={<NavIcon name="loyalty" />}
        title={t('pricing.memberships.title')}
        description={t('pricing.memberships.body')}
        action={
          Array.isArray(areas) ? (
            <ul className="console-pricing-areas" aria-label={t('soon.areasLabel')}>
              {(areas as readonly string[]).map((area) => (
                <li key={area}>
                  <Chip>{area}</Chip>
                </li>
              ))}
            </ul>
          ) : undefined
        }
      />
    </div>
  );
}
